<template>
  <div class="no-income-notification">
    <div class="no-income-notification-title ri-bold-body">
      יכול להיות שבחשבון שחיברת אין פעילות?
    </div>
    <div class="no-income-notification-subtitle ri-body">
      כדי להבין כמה ניתן לחסוך על המשכנתא, עדיין חסרים לנו חשבונות בנק ואשראי.
    </div>
    <img class="bank-icon" :src="require('@/assets/icons/account_balance_24dp_white.svg')" />
  </div>
</template>

<script>
import Segment from '@/Segment';

export default {
  name: 'NoIncomeNotification',
  created() {
    Segment.trackUserGot('OTS_NoIncomeNotification_Shown');
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.no-income-notification {
  background-color: $riseup_red;
  color: white;
  padding: 20px;
  padding-right: 56px;
  position: relative;
  overflow: hidden;

  .bank-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
    color: white;
  }

  .no-income-notification-title {
    margin-bottom: 8px;
  }
}
</style>
